const footer = {
  copyright: "कॉपीराइट © 2022 HitPaw. कॉ., लिमिटेड. सभी अधिकार सुरक्षित।",
};

export default footer;
